export default (fn, options = {}) => {
  let {
    delay = 100,
    storage = [],
    reducer = null,
    timer = null,
    resolver = null
  } = options;

  return value => {
    if (timer) {
      clearTimeout(timer);
    }

    if (resolver) {
      resolver();
    }

    storage = [...storage, value];

    return new Promise(resolve => {
      resolver = resolve;
      timer = setTimeout(() => {
        if (reducer) {
          storage = storage.reduce(reducer, []);
        }

        const promises = fn(storage);

        timer = null;
        resolver = null;
        storage = [];

        if (Array.isArray(promises) && promises.length) {
          resolve(Promise.all(promises));
        } else {
          resolve(Promise.resolve());
        }
      }, delay);
    });
  };
};
